import { connect } from 'react-redux';
import _ from 'lodash';
import DeviceService from '../services/api/device_service';
import DeviceActions from '../actions/device_actions';
import DeviceManager from '../components/device_manager/device_manager';

function mapStateToProps({ guest, devices }) {
  return {
    invite: guest.invite,
    pairedDevices: _.chain(devices.pairedDevices).values().orderBy(['updatedAt'], ['desc']).value(),
    pairing: devices.pairing,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActions: deviceActions => ({
      loadDevices: () => dispatch(deviceActions.loadDevices()),
      pairDevice: (code, name) => dispatch(deviceActions.pairDevice(code, name)),
      unpairDevice: deviceId => dispatch(deviceActions.unpairDevice(deviceId)),
    }),
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const inviteId = stateProps.invite && stateProps.invite.inviteId;
  const deviceService = new DeviceService(inviteId);
  const deviceActions = new DeviceActions(deviceService);

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps.getActions(deviceActions),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeviceManager);



// WEBPACK FOOTER //
// ./src/containers/device_manager.js